<template>
  <v-container
    id="register"
    class="fill-height"
    tag="section"
  >
    <v-row justify="center">
      <v-col cols="3">
        <v-slide-y-transition appear>
          <base-material-card
            color="coolrunner"
            light
            max-width="100%"
            width="400"
            class="px-5 py-3"
          >
            <template v-slot:heading>
              <div class="text-center">
                <h1 class="text-h2 font-weight-bold">
                  {{ $t('register') }}
                </h1>
              </div>
            </template>

            <v-col
              cols="12"
            >
              <div class="text-center">
                <v-text-field
                  v-model="userData.name"
                  color="secondary"
                  :label="$t('name') + '...'"
                  prepend-icon="
                  mdi-face"
                />

                <v-text-field
                  v-model="userData.email"
                  color="secondary"
                  :label="$t('email') + '...'"
                  type="email"
                  prepend-icon="mdi-email"
                />

                <v-text-field
                  v-model="userData.password"
                  class="mb-8"
                  color="secondary"
                  type="password"
                  :label="$t('password') + '...'"
                  prepend-icon="mdi-lock-outline"
                />

                <pages-btn
                  :loading="loading"
                  color="success"
                  @click="createUser"
                >
                  {{ $t('create') }}
                </pages-btn>
              </div>
            </v-col>
          </base-material-card>
        </v-slide-y-transition>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'PagesRegister',

    components: {
      PagesBtn: () => import('./components/Btn'),
    },

    data: () => ({
      userData: {
        name: '',
        email: '',
        password: '',
      },
      loading: false,
    }),
    methods: {
      createUser: function () {
        this.loading = true
        this.$post('/user', this.userData).then(res => {
          this.$router.push({ name: 'Login', params: { email: this.userData.email, password: this.userData.password } })
          this.$toast(this.$t('user_created'), { color: 'green', timeout: 15000 })
          this.loading = false
        })
          .catch(() => { this.loading = false },
          )
      },
    },
  }
</script>

<style lang="sass">
  #register
    .v-list-item__subtitle
      -webkic-line-clamp: initial
      -webkit-box-orient: initial
</style>
